import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { NgwWowService } from "ngx-wow";
import { Subscription } from "rxjs/Subscription";
import { CiacService } from "../../servicios/ciac.service";
import { tileLayer, latLng, marker, icon } from "leaflet";
import { NgForm } from "@angular/forms";
import Swal from "sweetalert2";
import { environment } from '../../../environments/environment';
import * as L from 'leaflet'
import { title } from "process";
import { logging } from 'protractor';


@Component({
  selector: 'app-solicitud',
  templateUrl: './solicitud.component.html',
  styleUrls: ['./solicitud.component.css']
})
export class SolicitudComponent implements OnInit {
  private wowSubscription: Subscription;
  @ViewChild("f", { static: false }) userFrm: NgForm;

  siteKey = environment.KEY_CAPTCHA;
  type = 'image';
  theme = 'Light';
  size2 = 'inline';
  lang = 'es';
  captcha = false;

  colonias: any[] = [];
  servicios: any[] = [];
  loading = true;

  master: any = {
    idsolicitud: 0,
    folio: "",
    IdServicio: "",
    idsexo: "1",
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    email: "",
    telefono: "",
    calle: "",
    numero: "",
    Idcolonia: "",
    entre_calle_1: "",
    entre_calle_2: "",
    comentarios: "",
    longitud: "",
    latitud: ""
  };
  forma: any = { ...this.master };
  folio: any;
  idsolicitud: any;
  nombre = "";
  imageSrc: any;
  repeat = "no-repeat";
  posicion = "50% 50%";
  size = "cover";
  constructor(private _ciacService: CiacService) { 
    this.getCatalogos();
    this.folio = "";
    this.idsolicitud = 0;
  }

  ngOnInit(): void {
  }

  getCatalogos() {
    this._ciacService.getCatalogosColonias().then((data: any) => {
      this.colonias = data;

    })
    this._ciacService.getCatalogosServicios().then((data: any) => {
      this.servicios = data;

    })
    /* this._ciacService.getCatalogos().subscribe(resp => {
       console.log(resp)
       this.colonias = resp[0].registros;
       this.servicios = resp[1].registros;
       this.loading = false;
     });*/
  }

  validarEmail() {
    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.forma.email)
    ) {
    } else {
      this.userFrm.form.controls["email"].setErrors({ incorrect: true });
    }
  }

  agregar(m: any) {
 
      this.loading = true;
      console.log(this.forma)
 
  }

}
